import React from "react";
import { Link } from "react-router-dom";

import Seo from "../seo/Seo";
import {
  organizationSchema,
  webPageSchema,
  breadcrumbSchema,
} from "../seo/schema";
import PageHeader from "../components/PageHeader";
import Breadcrumbs from "../components/Breadcrumbs";
import { CONTACT_EMAIL } from "../data/site";
import { useNowIST } from "../lib/useResults";

const PATH = "/privacy-policy";

const Privacy = () => {
  const nowIST = useNowIST();

  const title = "Privacy Policy | Bagad Satta Company";
  const description =
    "How Bagad Satta Company handles visitor data: what we collect, what we do not collect, cookies, third-party services and how to contact us about your data.";

  const trail = [
    { name: "Home", path: "/" },
    { name: "Privacy Policy", path: PATH },
  ];

  return (
    <>
      <Seo
        path={PATH}
        title={title}
        description={description}
        schema={[
          organizationSchema(),
          webPageSchema({ path: PATH, title, description }),
          breadcrumbSchema(trail),
        ]}
      />

      <div className="page-banner">
        <div className="container page-padding">
          <Breadcrumbs trail={trail} />
          <PageHeader h1="Privacy Policy" nowIST={nowIST} />

          <section className="card text-content">
            <h2>What We Collect</h2>
            <p>
              You can read every result and every chart on this website without
              creating an account, logging in or giving us any personal
              information. We do not ask for your name, phone number or address
              anywhere on this site.
            </p>

            <h2>Information Collected Automatically</h2>
            <p>
              Like most websites, our hosting provider records standard technical
              request data — IP address, browser type, device type, referring
              page and the time of the request. This is used to keep the site
              running and to understand traffic levels in aggregate.
            </p>

            <h2>Cookies and Local Storage</h2>
            <p>
              We do not use cookies to profile you or to track you across other
              websites. Any storage used by this site is limited to keeping the
              page working, such as briefly caching result data in your browser
              so pages load faster.
            </p>

            <h2>Third-Party Services</h2>
            <p>
              Result data is loaded from Google Sheets, so your browser makes a
              request to Google&apos;s servers when a page loads. Pages also link
              to an external Android application. Those services have their own
              privacy policies, which we do not control.
            </p>

            <h2>Children</h2>
            <p>
              This website is not directed at anyone under 18, and we do not
              knowingly collect information from children.
            </p>

            <h2>Your Choices</h2>
            <p>
              You can block cookies and site storage in your browser settings.
              Doing so will not stop you from reading any result or chart here.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this policy from time to time. Any change takes
              effect as soon as it is published on this page.
            </p>

            <h2>Contact</h2>
            <p>
              Questions about this policy can be sent to{" "}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>, or via
              the <Link to="/contact-us">contact page</Link>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Privacy;
